const ageCalc = () => {
  const ageContainer = document.querySelector('.ftbl__player-page-info__data#age');
  if (ageContainer && ageContainer.textContent) {
    const birthDayPieces = ageContainer.textContent
      .replace(/^\s+|\s+$/g, '')
      .trim()
      .split('/')
      .map((v) => parseInt(v, 10));
    const birthDayDate = new Date(birthDayPieces[2], birthDayPieces[1] - 1, birthDayPieces[0]);
    const now = new Date();

    let age = now.getFullYear() - birthDayDate.getFullYear();
    if (
      now.getMonth() < birthDayDate.getMonth() ||
      (now.getMonth() === birthDayDate.getMonth() && now.getDate() < birthDayDate.getDate())
    ) {
      age--;
    }

    ageContainer.textContent = `${ageContainer.textContent} (${age})`;
  }
};

export default ageCalc;
